import {$document,$window,$htmlBody,$html,$body,$main,$footer} from './Variables';
import {scrollTo,getScrollBottom} from './ScrollTo';
import {show,hide} from './Toggle.js';

class BackToTop {
  constructor(element,target,options) {
    this.element = element;
    this.target = target;
    this.options  = options;
  }
  /**
   * [scroll description]
   * @return {[type]} [description]
   */
  setScroll() {
    const target = this.target,
    options = this.options;

    scrollTo(this.element,target,options);
  }
  /**
   * [toggle description]
   * @return {[type]} [description]
   */
  toggle() {
    let element = this.element,
    options = this.options;

    $window.on('scroll load',function(){
      const position = $window.scrollTop(),
      yFromFotter = getScrollBottom() - $footer.outerHeight(true);

      if ( position > options.position && yFromFotter > 0 ) {
        options.y = 0
        show(element,options);
      }else if (yFromFotter <= 0 ) {
        options.y = - $footer.outerHeight(true);
        show(element,options);
      }else {
        options.y = 200;
        hide(element,options);
      }
    });
  }
}

export default BackToTop